<template>
    <div class="row q-col-gutter-lg q-py-xl text-white">
        <div class="col-xs-12 col-sm-4">
            <q-list>
                <q-item>
                    <q-item-section avatar>
                        <q-icon color="white" name="fal fa-play" size="xl" />
                    </q-item-section>

                    <q-item-section>
                        <q-item-label class="text-h6 text-weight-bold">{{ info.qty_group_trainings && $t('more_than_courses', { courses: info.qty_group_trainings }) }}</q-item-label>
                        <q-item-label :caption="!!info.qty_group_trainings" lines="2" class="text-white">{{ $t('discover_new_techniques_in_current_and_diversified_courses') }}</q-item-label>
                    </q-item-section>
                </q-item>
            </q-list>
        </div>

        <div class="col-xs-12 col-sm-4">
            <q-list>
                <q-item>
                    <q-item-section avatar>
                        <q-icon color="white" name="fal fa-users" size="xl" />
                    </q-item-section>

                    <q-item-section>
                        <q-item-label class="text-h6 text-weight-bold">{{ info.qty_users && $t('active_users', { users: info.qty_users}) }}</q-item-label>
                        <q-item-label :caption="!!info.qty_users" lines="2" class="text-white">{{ $t('a_great_community_awaits_you') }}</q-item-label>
                    </q-item-section>
                </q-item>
            </q-list>
        </div>

        <div class="col-xs-12 col-sm-4">
            <q-list>
                <q-item>
                    <q-item-section avatar>
                        <q-icon color="white" name="fal fa-file-certificate" size="xl" />
                    </q-item-section>

                    <q-item-section>
                        <q-item-label class="text-h6 text-weight-bold">{{ info.qty_group_training_user_results && info.qty_group_training_user_results }}</q-item-label>
                        <q-item-label :caption="!!info.qty_group_training_user_results" lines="2" class="text-white">{{ $t('certificates_obtained_in_training') }}</q-item-label>
                    </q-item-section>
                </q-item>
            </q-list>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'InfoPortfolio',

    data() {
        return {
            info: {}
        }
    },

    computed: {
		...mapGetters({
            country: 'portfolio/country',
			show_portfolio_statistics: 'params/show_portfolio_statistics'
        })
    },

    methods: {
        getInfo() {
            if(!this.show_portfolio_statistics) return
            this.$axios.get(`/etraining_portfolio/info/${this.country.value}/`)
            .then(response => {
                this.info = response.data
            })
            .catch(e => {
                console.log(e)
            })
        }
    },

    watch: {
        country: {
            handler: function(newValue) {
                if (this.country) this.getInfo()
            }
        }
    }
}
</script>

<style>

</style>